let notificationSequence = 0;

function createNotificationId() {
  notificationSequence += 1;
  return `notification-${Date.now()}-${notificationSequence}`;
}

function normalizeNotification(notification = {}) {
  return {
    ...notification,
    id: String(notification.id ?? createNotificationId()),
    title: String(notification.title ?? "새 알림"),
    message: String(notification.message ?? ""),
    createdAt: notification.createdAt ?? new Date().toISOString(),
    read: notification.read === true,
    type: notification.type ?? "info",
    path: String(notification.path ?? ""),
    source: String(notification.source ?? "local"),
    sourceId: String(notification.sourceId ?? notification.id ?? ""),
    actionRequired: notification.actionRequired === true,
    scheduleId: String(notification.scheduleId ?? ""),
    requestStatus: String(notification.requestStatus ?? ""),
    rejectionReason: String(notification.rejectionReason ?? ""),
  };
}

function sortNotifications(notifications) {
  return [...notifications].sort((left, right) => {
    const rightTime = new Date(right.createdAt).getTime() || 0;
    const leftTime = new Date(left.createdAt).getTime() || 0;
    return rightTime - leftTime;
  });
}

export const createNotificationSlice = (set) => ({
  notifications: [],

  addNotification: (notification) => {
    const nextNotification = normalizeNotification(notification);

    set((state) => ({
      notifications: sortNotifications([
        nextNotification,
        ...state.notifications.filter(
          (currentNotification) =>
            currentNotification.id !== nextNotification.id,
        ),
      ]),
    }));

    return nextNotification.id;
  },

  syncNotifications: (notifications, sources = []) => {
    const synchronizedSources = new Set(sources.map(String));

    set((state) => {
      const existingReadIds = new Set(
        state.notifications
          .filter((notification) => notification.read)
          .map((notification) => notification.id),
      );
      const synchronizedNotifications = (Array.isArray(notifications)
        ? notifications
        : []
      ).map((notification) => {
        const normalized = normalizeNotification(notification);
        return existingReadIds.has(normalized.id)
          ? { ...normalized, read: true }
          : normalized;
      });
      const synchronizedIds = new Set(
        synchronizedNotifications.map((notification) => notification.id),
      );
      const retainedNotifications = state.notifications.filter(
        (notification) =>
          !synchronizedSources.has(notification.source) &&
          !synchronizedIds.has(notification.id),
      );

      return {
        notifications: sortNotifications([
          ...synchronizedNotifications,
          ...retainedNotifications,
        ]),
      };
    });
  },

  markNotificationRead: (notificationId) => {
    const normalizedId = String(notificationId ?? "");
    if (!normalizedId) return;

    set((state) => ({
      notifications: state.notifications.map((notification) =>
        notification.id === normalizedId
          ? { ...notification, read: true }
          : notification,
      ),
    }));
  },

  markAllNotificationsRead: () => {
    set((state) => ({
      notifications: state.notifications.map((notification) =>
        notification.read ? notification : { ...notification, read: true },
      ),
    }));
  },

  clearNotifications: () => {
    set({ notifications: [] });
  },
});
